<template>
  <div style="height:100%">
    <portal to="app-header">
      <span>{{ $t('downtime.title') }}</span>
      <v-btn icon small class="ml-4 mb-1">
        <v-icon
          v-text="'$info'"
        ></v-icon>
      </v-btn>
      <v-tooltip bottom v-if="!isMobile">
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            small
            v-on="on"
            v-bind="attrs"
            class="ml-2 mb-1"
            @click="gotToSettings"
          >
            <v-icon
              v-text="'$settings'"
            ></v-icon>
          </v-btn>
        </template>
        {{ $t('production.settingsTitle') }}
      </v-tooltip>
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            small
            v-on="on"
            v-bind="attrs"
            class="ml-2 mb-1"
            @click="refreshDowntimes"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        {{ $t('downtime.lastRefreshed') }} <strong>{{ lastRefreshedAt }}</strong>
      </v-tooltip>
    </portal>
    <downtime-log-loading v-if="loading" />
    <template v-else>
      <downtime-log-setup v-if="!onboarded" />
      <template v-else>
        <downtime-toolbar />
        <downtime-drawer />
        <downtime-list />
      </template>
    </template>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import DowntimeLogSetup from './DowntimeLogSetup.vue';
import DowntimeLogLoading from './DowntimeLogLoading.vue';
import DowntimeToolbar from '../components/DowntimeToolbar.vue';
import DowntimeDrawer from '../components/DowntimeDrawer.vue';
import DowntimeList from '../components/DowntimeList.vue';

export default {
  name: 'DowntimeLog',
  components: {
    DowntimeLogSetup,
    DowntimeLogLoading,
    DowntimeToolbar,
    DowntimeDrawer,
    DowntimeList,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState('downtimeLog', ['onboarded', 'lastRefreshedAt']),
    ...mapState('webApp', ['config', 'storageLocation']),
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  async created() {
    this.loading = true;
    await this.fetchSingleMachine();
    const config = localStorage.getItem(this.storageLocation.downtime);
    if (config) {
      this.setConfig(JSON.parse(config));
    } else {
      this.resetConfig();
    }
    this.setGroup(['shiftName']);
    await this.getOnboardingState();
    if (this.onboarded) {
      await Promise.all([
        this.getAppSchema(),
        this.fetchDowntimeReasons(),
      ]);
      this.setExtendedHeader(true);
    }
    this.loading = false;
  },
  methods: {
    ...mapMutations('webApp', ['setConfig', 'resetConfig', 'setGroup']),
    ...mapMutations('helper', ['setExtendedHeader']),
    ...mapActions('webApp', ['getAppSchema']),
    ...mapActions('downtimeLog', [
      'getOnboardingState',
      'fetchDowntimeReasons',
      'fetchDowntimeList',
      'fetchSingleMachine',
    ]),
    refreshDowntimes() {
      this.fetchDowntimeList();
    },
    gotToSettings() {
      this.$router.push({ name: 'downtimeLogSettings' });
    },
  },
  watch: {
    async onboarded(val) {
      if (val) {
        await Promise.all([
          this.getAppSchema(),
          this.fetchDowntimeReasons(),
        ]);
        this.setExtendedHeader(true);
      }
    },
    config: {
      deep: true,
      handler(val) {
        localStorage.setItem(this.storageLocation.downtime, JSON.stringify(val));
      },
    },
  },
};
</script>
